import { collectionConstants } from '../constants';

export function collections(state = {}, action) {
  switch (action.type) {
    case collectionConstants.GETALL_REQUEST:
      return {
        state,
        loading: true
      }
    case collectionConstants.GETALL_SUCCESS:
      return {
        ...state,
        items: action.items,
        total: action.total,
        loading: false
      }
    case collectionConstants.GETALL_FAILURE:
      return {
        ...state,
        error: action.error,
        loading: false
      };
    default:
      return state;
  }
}

export function AddCollection(state = {}, action) {
  switch (action.type) {
    case collectionConstants.ADD_REQUEST:
      return {
        state,
        loading: true,
      }
    case collectionConstants.ADD_SUCCESS:
      return {
        ...state,
        status: action.status,
        loading: false
      }
    case collectionConstants.ADD_FAILURE:
      return {
        ...state,
        error: action.error,
        loading: false,
        status: false
      };
    default:
      return state;
  }
}

export function GetCollection(state = {}, action) {
  switch (action.type) {
    case collectionConstants.GET_REQUEST:
      return {
        state,
        loading: true,
      }
    case collectionConstants.GET_SUCCESS:
      return {
        ...state,
        item: action.item,
        loading: false
      }
    case collectionConstants.GET_FAILURE:
      return {
        ...state,
        error: action.error,
        loading: false,
      };
    default:
      return state;
  }
}

export function UpdateCollection(state = {}, action) {
  switch (action.type) {
    case collectionConstants.UPDATE_REQUEST:
      return {
        state,
        loading: true,
      }
    case collectionConstants.UPDATE_SUCCESS:
      return {
        ...state,
        status: action.status,
        loading: false
      }
    case collectionConstants.UPDATE_FAILURE:
      return {
        ...state,
        error: action.error,
        loading: false,
        status: false
      };
    default:
      return state;
  }
}